import axios from "../../../services/axios-config.js";

export async function linkCommissionedCompany({ commissionedId, companyId, commissionValue }) {
  const res = await axios.post("/commissioned/companies/link", { commissionedId, companyId, commissionValue });
  return res?.data;
}
